import React from 'react';
import { Tag, Typography } from 'antd';
import type { RouteOperationalRecovery } from './types';
import './recoveryStrip.css';

const { Text } = Typography;

const STATE_COLORS: Record<string, string> = {
  NORMAL: 'success',
  DELAYED_BUT_CONTROLLED: 'warning',
  RECOVERY_IN_PROGRESS: 'processing',
  STABILIZING: 'success',
  DEGRADED: 'error',
  CRITICAL_RECOVERY: 'error'
};

export type RecoveryStripProps = {
  recovery: RouteOperationalRecovery;
  compact?: boolean;
};

export const RecoveryStrip: React.FC<RecoveryStripProps> = ({ recovery, compact = false }) => {
  const { adaptiveState, stabilization, paths, recoverySummary, coordinationNote } = recovery;

  if (adaptiveState.state === 'NORMAL' && !recoverySummary) return null;

  const stripClass = `recovery-strip recovery-strip--${adaptiveState.state.toLowerCase()}`;

  const bullets: string[] = [];
  if (recoverySummary) bullets.push(recoverySummary);
  if (coordinationNote) bullets.push(coordinationNote);
  for (const f of stabilization.factors.slice(0, 2)) bullets.push(f);
  const pathTitles = paths.paths.filter((p) => p.recommended).map((p) => p.title);
  bullets.push(...pathTitles);

  const unique = Array.from(new Set(bullets)).slice(0, 4);

  return (
    <section className={stripClass}>
      <div className="recovery-strip__head">
        <Text type="secondary">Recovery</Text>
        <Tag color={STATE_COLORS[adaptiveState.state] ?? 'default'}>{adaptiveState.label}</Tag>
        <Tag color={stabilization.trend === 'improving' ? 'success' : stabilization.trend === 'degrading' ? 'error' : 'default'}>
          {stabilization.label}
        </Tag>
      </div>
      {!compact && unique.length > 0 ? (
        <ul>
          {unique.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default RecoveryStrip;
